﻿$.fn.dxCtrlTextBox = function custom_dxCtrlTextBox(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrltextbox dx-ctrl");
        this.createInstance(new cdxCtrlTextBox(this, option));
    }
    return this;
}

window.cdxCtrlTextBox = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = null;
    if (typeof option.showClearButton == 'undefined') option.showClearButton = false;
    if (typeof option.disablePropagation == 'undefined') option.disablePropagation = false;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return dx.option(name);
        }
        else {
            dx.option(name, value);
        }
    }

    var dx = null;
    var tt = null;
    var jauge = null;
    this.mGetJauge = function () {
        if (!jauge) jauge = $("<div/>").appendTo(dx.element()).dxCtrlJauge({ width: 30, height: 30 }).dxCtrlJauge("instance");
        return jauge
    }

    var valueBeforeFocus = null;
    this.escapeDown = false;
    function mConstruit() {
        container.empty();
        if (typeof option.obligatoire != 'undefined' && option.obligatoire) container.addClass("saisie_obligatoire")

        container.addClass("allowcontextmenu")

        option.value = option.value ?? ""
        valueBeforeFocus = option.value;

        var oncontentready = option.onContentReady
        if (option.mode == "password") {
            option.onContentReady = function (e) {
                var input = $(container.find("input"))
                input.attr('autocomplete', 'fakeautocomplete');
                e.component.element().find("input").addClass("txtPassword")
                if (typeof oncontentready != 'undefined') oncontentready(e)
            }
            option.mode = "text"
        } else {
            option.onContentReady = function (e) {
                var input = $(container.find("input"))
                input.attr('autocomplete', 'fakeautocomplete');
                //$(e.component.element().find("input")).attr("autocomplete", "false")
                if (typeof oncontentready != 'undefined') oncontentready(e)
            }
        }

        var onValueChanged = option.onValueChanged
        option.onValueChanged = function (e) {
            if (!Me.escapeDown) {
                if (typeof e.value != 'undefined' && e.value != null && typeof e.value.trim != 'undefined') e.value = e.value.trim();
                if (typeof onValueChanged != 'undefined') onValueChanged(e);
            }
        }
        var onKeyDown = option.onKeyDown
        option.onKeyDown = function (e) {
            mReplaceBarre()
            var trouver = false
            if (e.event.key == "Escape") {
                Me.escapeDown = true;
                dx.option("value", valueBeforeFocus)
                dx.option("text", valueBeforeFocus)
                dx.blur();
            }
            else {
                Me.escapeDown = false
                if (typeof option.carAutorise != 'undefined') {
                    switch (e.event.key) {
                        case "Backspace": case "Delete": break;
                        case "ArrowRight": case "ArrowLeft": case "ArrowDown": case "ArrowUp": break;
                        case "End": case "Home": break;
                        case "Control": case "Shift": case "CapsLock": case "NumLock": break;
                        case "Alt": break;
                        default:
                            if (!option.carAutorise.contains(e.event.key)) {
                                e.event.stopPropagation();
                                e.event.preventDefault();
                                tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                    target: container,
                                    showCloseButton: false,
                                    position: "bottom",
                                    contentTemplate: function (contentElement) {
                                        $("<div>" + option.carAutorisePhrase + "</div>").appendTo(contentElement);
                                    }
                                }).dxCtrlTooltip("instance");
                                tt.show();
                                return;
                            }
                            break;
                    }
                }
                else {
                    if (typeof option.carInterdit != 'undefined' && option.carInterdit.length > 0) {
                        option.carInterdit.forEach(function (car) {
                            if (car == e.event.key) trouver = true;
                        })
                        if (trouver) {
                            e.event.stopPropagation();
                            e.event.preventDefault();
                            tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                target: container,
                                showCloseButton: false,
                                position: "bottom",
                                contentTemplate: function (contentElement) {
                                    var txt = "";
                                    option.carInterdit.forEach(function (car) {
                                        if (txt.length > 0) txt += "  ";
                                        txt += car;
                                    })
                                    $("<div>Un nom de fichier ou de répertoire ne peut pas contenir les caractères suivants:<br/>" + txt + "</div>").appendTo(contentElement);
                                }
                            }).dxCtrlTooltip("instance");
                            tt.show();
                            return;
                        }
                    }
                }
                if (tt) tt.hide();
                if (!trouver && typeof onKeyDown != 'undefined') onKeyDown(e);
            }
        };
        var onFocusOut = option.onFocusOut
        option.onFocusOut = function (e) {
            valueBeforeFocus = e.component.option("value")
            if (typeof onFocusOut != 'undefined') onFocusOut(e);
            Me.escapeDown = false
        };

        if (typeof option.inputAttr == 'undefined') option.inputAttr = {}
        option.inputAttr.autocomplete= 'test-autocomplete'
        if (typeof option.multiline != 'undefined' && option.multiline) {
            if (typeof option.maxHeight == 'undefined' || option.maxHeight == null) {
                option.maxHeight = ((typeof option.height == 'undefined' || option.height ==null) ? 110 : option.height);
            }
            option.autoResizeEnabled = true
            dx = $("<div style='position:relative;min-height:80px;'/>").appendTo(container).dxTextArea(option).dxTextArea("instance");
            dx.element().find(".dx-texteditor-container").css("min-height", "80px")
            dx.element().find(".dx-texteditor-input").css("min-height", "50px")
            window.setTimeout(function () { dx.repaint(); },50)
        }
        else { dx = $("<div style='position:relative'/>").appendTo(container).dxTextBox(option).dxTextBox("instance"); }

        if (typeof option.txtTooltip != 'undefined' && option.txtTooltip.length > 0) {
            container.attr("title", option.txtTooltip.remplacerTout("<br/>", "%cr%"))
            //tt = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: container, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>" + option.txtTooltip + "</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
        }

        if (option.disablePropagation) container.on("click", function (e) { e.stopPropagation(); })

        if (typeof option.multiline != 'undefined' && option.multiline && typeof option.maxHeight != 'undefined' && option.maxHeight!=null) {
            //on fait cela car la barre horizonthel du bas est mal placée quand max-height
            mReplaceBarre()
            //window.setTimeout(function () {
            //    dx.element().css("height", "auto")
            //    window.setTimeout(function () {
            //        dx.element().css("height", "auto")
            //        window.setTimeout(function () { dx.element().css("height", "auto") }, 1000)
            //    }, 100)
            //}, 0)
        }
    }

    function mReplaceBarre() {
        window.setTimeout(function () {
            dx.element().css("max-height", (option.maxHeight + 5) + "px")
            window.setTimeout(function () {
                dx.element().css("max-height", (option.maxHeight + 5) + "px")
                window.setTimeout(function () { dx.element().css("max-height", (option.maxHeight + 5) + "px") }, 1000)
            }, 100)
        }, 0)
    }

    this.component = function () { return dx; }
    this.element = function () { return container; }
    this.focus = function () { dx.focus(); }

    
    mConstruit();
}